/* eslint-disable */
import React, { useEffect, useRef } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import AddAlert from "@material-ui/icons/AddAlert";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DoneAllIcon from "@material-ui/icons/DoneAll";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Tooltip from "@material-ui/core/Tooltip";
import Badge from "@material-ui/core/Badge";

import CustomInput from "components/CustomInput/CustomInput.jsx";

import { API_GET, API_POST } from "../../services/api.service";

// Import underscore.js for data manipulation
import _ from "underscore";

import Loader from "components/Loader/Loader.jsx";
import DataTable from "react-data-table-component";

// Import notification sound
import notificationSound from "../../assets/sounds/notification.mp3";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0",
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF",
        },
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1",
        },
    },
};

class AddNotification extends React.Component {
    constructor(props) { 
        super(props);
        const { user } = this.props;

        this.state = {
            teamuser: [{ key: 'Select', value: 0 }],
            showLoader: true,
            _id: null,
            mode: "Add",
            records: null,
            showSnackbar: false,
            snackbarMessage: "",
            snackbarColor: "info",
            lastNotificationCount: 0
        };
        const defaultData = {
            type: 'onetoone',
            user: [],
            read: 0,
            message: '',
            prospectId: null,
            IsActive: true,
            createdOn: null,
            updatedOn: null,
            admin: user && user.admin,
        };

        this.state.notificationDetails = defaultData;
        this.audioRef = React.createRef();
    }




    // to stop the warning of calling setState of unmounted component
    componentDidMount() {
        const { user } = this.props;
        let id = this.props.match.params.id;
        this.setState({ showLoader: false });
        if (user) {
            this.loadUsers(user.id);
            this.loadRecords(user);
            
            // Set up polling for new notifications every 30 seconds
            this.notificationInterval = setInterval(() => {
                this.loadRecords(user);
            }, 30000);
        }
    }
    
    componentWillUnmount() {
        // Clear the interval when component unmounts
        if (this.notificationInterval) {
            clearInterval(this.notificationInterval);
        }
    }
    
    // Play notification sound
    playNotificationSound = () => {
        if (this.audioRef.current) {
            this.audioRef.current.play().catch(e => {
                console.log("Audio play failed:", e);
            });
        }
    }



    loadRecords = async (user) => {
        if (!user || (user && !user.admin)) {
            return;
        }

        let registerRequest = await API_POST("action/getdata", {
            root: "notifications",
            con: { admin: user && user.admin },
            cols: {},
        });

        // Sort notifications by createdOn in descending order (newest first)
        let sortedData = [];
        if (registerRequest && registerRequest.data) {
            // Use underscore.js to sort the data
            sortedData = _.sortBy(registerRequest.data, 'createdOn').reverse();
            console.log('Notifications sorted by date (newest first):', sortedData);
            
            // Check if we have new notifications
            const { lastNotificationCount } = this.state;
            const currentCount = sortedData.length;
            
            if (lastNotificationCount > 0 && currentCount > lastNotificationCount) {
                // We have new notifications, play sound and show snackbar
                this.playNotificationSound();
                this.setState({
                    showSnackbar: true,
                    snackbarMessage: `You have ${currentCount - lastNotificationCount} new notification(s)`,
                    snackbarColor: "info"
                });
                
                // Auto-close snackbar after 3 seconds
                setTimeout(() => {
                    this.setState({ showSnackbar: false });
                }, 3000);
            }
            
            // Update the notification count
            this.setState({ lastNotificationCount: currentCount });
        }

        this.setState({
            records: sortedData,
        });
    }

    loadUsers = async (userid) => {
        if (userid) {
            let userInfo = await API_GET(`register/GetAllMembersByUserId?id=${userid}`);
            if (userInfo.success) {

                if (userInfo.data.ActiveMembers) {

                    var teamuUserData = [];
                    userInfo.data.ActiveMembers.map((val, key) => {
                        if (val.is_active && val.role != "owner") {
                            var tempobj = {};
                            tempobj.key = val.email;
                            tempobj.value = val.email;
                            teamuUserData.push(tempobj);
                        }
                    })

                    // console.log(teamuUserData);



                    this.setState({
                        teamuser: teamuUserData,
                    });
                }
            } else {
                this.setState({ userInfo: null });
            }
        }

    }


    handleChange = async (e) => {

        let formValue = this.state.notificationDetails;

        if (e.target && e.target.type === "checkbox") {
            formValue[e.target.id] = e.target.checked;
        } else if (e._isAMomentObject) {
            formValue[props] = e.format();
        } else {
            formValue[e.target.name] = e.target.value === "" ? null : e.target.value;
        }

        console.log(formValue);
        this.setState({ notificationDetails: formValue });
    };


    handleCancel = async (e) => {
        const { user, history } = this.props;
        history.push("/admin/addnotification");
    };

    handleSave = async (e) => {

        this.handleAddNotification(e);

    };

    handleAddNotification = async (e) => {
        const { user, history } = this.props;
        let formValue = this.state.notificationDetails;
        
        // Validate input data
        if (!formValue.message || formValue.message.trim() === '') {
            this.setState({
                showSnackbar: true,
                snackbarMessage: "Message cannot be empty",
                snackbarColor: "danger"
            });
            setTimeout(() => {
                this.setState({ showSnackbar: false });
            }, 3000);
            return;
        }
        
        if (!formValue.user || formValue.user.length === 0) {
            this.setState({
                showSnackbar: true,
                snackbarMessage: "Please select at least one user",
                snackbarColor: "danger"
            });
            setTimeout(() => {
                this.setState({ showSnackbar: false });
            }, 3000);
            return;
        }
        
        formValue["type"] = 'message';
        formValue["admin"] = user && user.username;
        formValue["createdBy"] = user && user.username;
        formValue["createdOn"] = new Date();

        let registerRequest;
        try {
            const result = await Promise.all(formValue.user.map(async (val) => {
                const notificationData = {
                    ...formValue,
                    user: val
                };
                
                registerRequest = await API_POST("action/addRecord", {
                    root: "notifications",
                    body: notificationData,
                });
                
                var registerRequest2 = await API_POST("action/PushNotification", {
                    body: notificationData,
                });
                
                return registerRequest;
            }));

            if (result) {
                // Show success message
                this.setState({
                    showSnackbar: true,
                    snackbarMessage: "Notification sent successfully",
                    snackbarColor: "success"
                });
                
                // Reset form and reload records
                const defaultData = {
                    type: 'onetoone',
                    user: [],
                    read: 0,
                    message: '',
                    prospectId: null,
                    IsActive: true,
                    createdOn: null,
                    updatedOn: null,
                    admin: user && user.admin,
                };
                
                this.setState({ notificationDetails: defaultData });
                this.loadRecords(user);
                
                // Auto-close snackbar after 3 seconds
                setTimeout(() => {
                    this.setState({ showSnackbar: false });
                }, 3000);
            }
        } catch (error) {
            console.log(error);
            this.setState({
                showSnackbar: true,
                snackbarMessage: "Error sending notification",
                snackbarColor: "danger"
            });
            setTimeout(() => {
                this.setState({ showSnackbar: false });
            }, 3000);
        }
    };



    render() {

        const columns = [
            {
                name: "User",
                cell: (row) => (
                    <span>
                        {row.user}
                    </span>
                ),
            },
            {
                name: "Message",
                cell: (row) => (
                    <div style={{ 
                        maxWidth: '400px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        padding: '8px',
                        backgroundColor: '#f5f5f5',
                        borderRadius: '4px',
                        border: '1px solid #e0e0e0',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                    }}>
                        <div dangerouslySetInnerHTML={{ __html: row.message }} />
                    </div>
                ),
            },

            {
                name: "Created On",
                cell: (row) => (
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <span style={{ 
                            backgroundColor: '#e3f2fd', 
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            color: '#1976d2',
                            fontWeight: '500'
                        }}>
                            {row.createdOn &&
                                window.moment(row.createdOn).format("DD-MMM-YYYY HH:mm")}
                        </span>
                        {row.read === 0 && (
                            <Tooltip title="Unread notification">
                                <Badge color="secondary" variant="dot">
                                    <NotificationsActiveIcon style={{ fontSize: '18px', color: '#f44336' }} />
                                </Badge>
                            </Tooltip>
                        )}
                        {row.read === 1 && (
                            <Tooltip title="Read notification">
                                <DoneAllIcon style={{ fontSize: '18px', color: '#4caf50' }} />
                            </Tooltip>
                        )}
                    </div>
                ),
            },


        ];
        const countPerPage = 10;
        const { classes, user } = this.props;
        const {
            records,
            notificationDetails,
            dispositions,
            customFormFields,
            mode,
            teamuser,
            showLoader,
        } = this.state;

        return (
            <>
                {/* Audio element for notification sound */}
                <audio ref={this.audioRef} src={notificationSound} preload="auto" />
                
                {/* Snackbar for notifications */}
                <Snackbar
                    place="tr"
                    color={this.state.snackbarColor}
                    icon={AddAlert}
                    message={this.state.snackbarMessage}
                    open={this.state.showSnackbar}
                    closeNotification={() => this.setState({ showSnackbar: false })}
                    close
                />
                
                <>
                    {showLoader ? <Loader /> : null}
                    {showLoader ? null : (
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader color="white">
                                        <h3>Manage Notification</h3>
                                    </CardHeader>
                                    <CardBody>
                                        <GridContainer>
                                            <GenerateField
                                                value={
                                                    notificationDetails && notificationDetails.user
                                                }
                                                onChange={this.handleChange}
                                                id={"user"}
                                                label={"Select User *"}
                                                type="checkbox_list"
                                                keyValuePair={teamuser}
                                            />

                                            <GridItem xs={12} sm={12} md={12}>

                                                <div>
                                                    <label style={{ 
                                                        color: '#555', 
                                                        fontSize: '14px',
                                                        marginBottom: '8px',
                                                        display: 'block'
                                                    }}>
                                                        Message * <small>(HTML formatting supported)</small>
                                                    </label>
                                                    <textarea
                                                        style={{
                                                            width: '100%',
                                                            padding: '12px',
                                                            borderRadius: '4px',
                                                            border: '1px solid #ddd',
                                                            minHeight: '150px',
                                                            fontFamily: 'inherit',
                                                            fontSize: '14px',
                                                            resize: 'vertical'
                                                        }}
                                                        value={notificationDetails && notificationDetails.message}
                                                        onChange={(e) => {
                                                            const formValue = this.state.notificationDetails;
                                                            formValue.message = e.target.value;
                                                            this.setState({ notificationDetails: formValue });
                                                        }}
                                                        name="message"
                                                        id="message"
                                                        placeholder="Enter your message here. HTML formatting is supported (e.g., <b>bold</b>, <i>italic</i>, <a href='...'>links</a>)"
                                                    />
                                                </div>

                                            </GridItem>



                                        </GridContainer>
                                    </CardBody>

                                    <CardFooter>
                                        <Button color="primary"
                                            size="sm"
                                            onClick={this.handleCancel}>
                                            Cancel
                                        </Button>
                                        <Button color="primary"
                                            size="sm"
                                            onClick={this.handleSave}>
                                            Save
                                        </Button>
                                    </CardFooter>
                                </Card>
                            </GridItem>

                        </GridContainer>


                    )}
                </>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="white">
                                <h3>View Notification </h3>

                            </CardHeader>

                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                        <h4 style={{ 
                                            color: '#3f51b5', 
                                            borderBottom: '2px solid #e0e0e0', 
                                            paddingBottom: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            <NotificationsActiveIcon /> 
                                            Notification History
                                            {records && records.length > 0 && (
                                                <Badge 
                                                    badgeContent={records.length} 
                                                    color="primary"
                                                    style={{ marginLeft: '8px' }}
                                                />
                                            )}
                                        </h4>
                                    </div>
                                    <DataTable
                                        columns={columns}
                                        data={records || []}
                                        highlightOnHover
                                        pagination
                                        paginationPerPage={countPerPage}
                                        paginationComponentOptions={{
                                            noRowsPerPage: true,
                                        }}
                                        noDataComponent={
                                            <div style={{ 
                                                padding: '24px', 
                                                textAlign: 'center',
                                                color: '#666'
                                            }}>
                                                No notifications found
                                            </div>
                                        }
                                        customStyles={{
                                            rows: {
                                                style: {
                                                    minHeight: '72px',
                                                    fontSize: '14px',
                                                    '&:hover': {
                                                        backgroundColor: '#f5f5f5 !important',
                                                    },
                                                },
                                            },
                                            headCells: {
                                                style: {
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    color: '#3f51b5',
                                                },
                                            },
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>

                        </Card>
                    </GridItem>
                </GridContainer>



            </>
        );
    }
}

export default withStyles(styles)(AddNotification);

class GenerateField extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {
            value,
            onChange,
            id,
            options,
            label,
            keyValuePair,
            type = "select",
            disabled = false,
        } = this.props;

        return (
            <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                    labelText={label}
                    id
                    labelProps={{ shrink: true }}
                    formControlProps={{
                        fullWidth: true,
                        multiline: true,
                    }}
                    customOptions={options}
                    inputProps={{
                        required: false,
                        value,
                        defaultValue: value,
                        checked: value,
                        name: id,
                        id: id,
                        type: type,
                        onChange,
                        disabled,
                        options: keyValuePair,
                    }}
                />
            </GridItem>
        );
    }
}
